import Button from '@mui/material/Button'
import { Modal } from 'antd'
import React from 'react'
import switchGeeks from '../../../assets/images/switchGeeks.png'
import { updateCustomerStartMeetingResponse } from '../../../utils'

const SwitchGeeksModal = ({
	setShowUpdateJobModal,
	switchGeekModal,
	setModalAction,
	job,
	setLeaveTheMeeting,
	showEndMeetingSpinner,
	countdown,
	socket,
	handleBackDropChange,
	setCustomerModalAction,
	initialCustomerModalAction,
	user,
	transferReason,
}) => {
	const transferCall = () => {
		socket.emit('confirm-transfer-execution', { jobId: job.id })
		setModalAction('resetAll')
		updateCustomerStartMeetingResponse(job.id, 'Transfer Confirmed', user.id)
		
		// Mark modal as completed and clean up localStorage
		const completedModalAction = {
			...initialCustomerModalAction,
			modalStatus: 'completed',
			timestamp: Date.now()
		}
		setCustomerModalAction(completedModalAction)
		
		handleBackDropChange('jobId', job.id)
		handleBackDropChange('isBackdropVisible', true)
		
		// Clean up localStorage after action
		setTimeout(() => {
			localStorage.removeItem('customerModalAction')
			localStorage.removeItem('customerResponceBackForTransfer')
		}, 500)
	}

	const handleEndMeeting = () => {
		// Mark modal as completed before ending meeting
		const completedModalAction = {
			...initialCustomerModalAction,
			modalStatus: 'completed',
			timestamp: Date.now()
		}
		setCustomerModalAction(completedModalAction)
		
		// Clean up localStorage
		localStorage.removeItem('customerModalAction')
		localStorage.removeItem('customerResponceBackForTransfer')
		
		setLeaveTheMeeting(true)
	}

	return (
		<>
			<Modal visible={switchGeekModal} width={800} closable={false} footer={null} className={'customer-meeting-confirmation-modal'}>
				<div className="customer-meeting-confirmation-modal-heading">
					{/* <img src={switchGeeks} className="customer-meeting-confirmation-modal-image" /> */}
					<span className="customer-meeting-confirmation-modal-heading-text">Let’s get you the right expert</span>
				</div>
				<div className="text-center">
					<span className="customer-meeting-confirmation-modal-text-span">
						Your current expert will transfer you to a colleague with more experience in this area. You'll be connected shortly.
					</span>
				</div>
				{transferReason && (
					<div className="text-center mt-3">
						<span className="customer-meeting-confirmation-modal-text-span" style={{ fontWeight: 'bold' }}>
							Reason: {transferReason}
						</span>
					</div>
				)}
				<div className="customer-meeting-confirmation-modal-button-div" style={{ display: 'flex', gap: '20px', justifyContent: 'center', alignItems: 'center' }}>
					<Button 
						variant="outlined" 
						onClick={handleEndMeeting}
						style={{ 
							display: 'flex',
							minWidth: '180px',
							minHeight: '60px',
							padding: '20px 32px',
							justifyContent: 'center',
							alignItems: 'center',
							borderRadius: '15px',
							border: '2px solid rgba(31, 185, 176, 0.60)',
							background: '#FAFBFB',
							textTransform: 'none'
						}}
					>
						<span style={{ 
							color: '#2F3F4C',
							fontFamily: 'Nova, sans-serif',
							fontSize: '20px',
							fontWeight: 700,
							lineHeight: '150%',
							textTransform: 'none'
						}}>End Meeting</span>
					</Button>
					<Button 
						variant="contained" 
						className="customer-meeting-confirmation-modal-button" 
						onClick={transferCall}
						style={{
							display: 'flex',
							minWidth: '180px',
							minHeight: '60px',
							padding: '20px 32px',
							justifyContent: 'center',
							alignItems: 'center',
							borderRadius: '15px',
							background: '#13BCBD',
							textTransform: 'none'
						}}
					>
						<span style={{ 
							color: '#FFF',
							fontFamily: 'Nova, sans-serif',
							fontSize: '20px',
							fontWeight: 700,
							lineHeight: '150%',
							textTransform: 'none'
						}}>Transfer ({countdown})</span>
					</Button>
				</div>
				<div className="text-center mt-2">
					<span className="customer-meeting-confirmation-modal-text-span" style={{ fontSize: '0.9rem', color: '#666' }}>
						Transfer will happen automatically in {countdown} seconds
					</span>
				</div>
			</Modal>
		</>
	)
}

export default SwitchGeeksModal
